import isNull from 'lodash/isNull'
import isUndefined from 'lodash/isUndefined'

export const getProfilePhoto = (userPhoto, userName) => 
  isNull(userPhoto) || isUndefined(userPhoto) 
    ? `https://ui-avatars.com/api/?name=${userName}&size=512&&color=FFFFFF&background=4486F8`
    : userPhoto
